import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./CancelWorkflowDialog.module.scss";
import BootstrapDialogTitle from "../../components/BootstrapDialogTitle";

interface Props {
  open: boolean;
  yesAction: () => void;
  noAction: () => void;
}

const CancelWorkflowDialog: React.FC<Props> = ({
  open,
  yesAction,
  noAction,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog className={styles.cancelDialog} open={open} fullWidth maxWidth="sm">
      <BootstrapDialogTitle onClose={noAction}>
        {t("cancelPublication")}
      </BootstrapDialogTitle>
      <DialogContent>
        <p>{t("areYouSureYouWantToCancel")}</p>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.yes}
          variant="contained"
          onClick={() => yesAction()}
        >
          {t("yes")}
        </Button>
        <Button
          className={styles.no}
          variant="contained"
          onClick={() => noAction()}
        >
          {t("no")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelWorkflowDialog;
